import React from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "./useful.css";
import Carousel from "react-elastic-carousel";
import moment from "jalali-moment";
// import "react-multi-carousel/lib/styles.css";
import Button from "react-bootstrap/Button";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
//input
export function Myinput(props) {
  return (
    <div class={props.class}>
      <div class="form-group textg">
        <label class="control-label" for={props.id}>
          {props.name}
        </label>
        <input
          id={props.id}
          type={props.type}
          class="contactInput form-control"
          name={props.name}
          placeholder={props.placeholder}
        />
      </div>
    </div>
  );
}

//logo
export function Mylogo(props) {
  return (
    <div>
      <img src={props.src} alt={props.alt} class={props.class} />
    </div>
  );
}

//drapdown list
export function MySelect(props) {
  return (
    <div class={props.class}>
      <div class="textg">
        <label class="control-label " for="first_name">
          {props.name}
        </label>
        <Select options={props.options} />
      </div>
    </div>
  );
}

//titel
export function Title1(props) {
  return (
    <div class="textg">
      <h4>{props.name}</h4>
    </div>
  );
}

export function Navbars(props) {
  return (
    <div
      class="row textg"
      style={{ backgroundColor: "#d0ae5e", height: "60px" }}
    >
      <h4>{props.name}</h4>
    </div>
  );
}
export class ModalDetailAds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  responsive = {
    largedesktop: {
      breakpoint: { max: 5000, min: 992 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    desktop: {
      breakpoint: { max: 992, min: 768 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div className="m-3">
              <Carousel
                showArrows={true}
                pagination={false}
                // responsive={true}
                itemsToShow={1}
                itemsToScroll={1}
                enableSwipe={true}
              >
                {this.props.pic &&
                  this.props.pic.map((item, index) => {
                    return (
                      <div>
                        {" "}
                        <img
                          height={300}
                          src={`https://macks-b.ir/${item}`}
                        />{" "}
                      </div>
                    );
                  })}
              </Carousel>
            </div>

            <div className="mt-3">
              <span className="float-right"> : آدرس </span>
              {this.props.address}
            </div>
            <div>
              {this.props.adsCategoryName}
              <span className="float-right"> : دسته بندی </span>
            </div>
            <div>
              {this.props.customerName}
              <span className="float-right"> : نام مشتری </span>
            </div>
            <div>
              {this.props.phone}
              <span className="float-right"> : شماره تماس مشتری </span>
            </div>
            <div>
              {this.props.description}
              <span className="float-right"> : توضیحات </span>
            </div>
            <div>
              {this.props.provinceName}
              <span className="float-right"> : استان </span>
            </div>
            <div>
              {this.props.townName}
              <span className="float-right"> : شهرک صنعتی </span>
            </div>
            {this.props.createDateTime && (
              <div>
                {this.props.createDateTime &&
                  moment(
                    this.props.createDateTime && this.props.createDateTime,
                    "YYYY-MM-DD"
                  )
                    .locale("fa")
                    .format("YYYY/MM/DD") +
                    "--" +
                    this.props.createDateTime.substring(11, 19)}
                <span className="float-right"> : تاریخ </span>
              </div>
            )}
            <div>
              {this.props.userName}
              <span className="float-right"> : نام ادمین شهرک </span>
            </div>
            <div>
              {this.props.mobile1}
              <span className="float-right"> : شماره تماس ادمین </span>
            </div>
            <div>
              {this.props.mobile2}
              <span className="float-right"> : شماره تماس دوم ادمین </span>
            </div>
            <div>
              {this.props.rejectingReason}
              <span className="float-right"> : دلیل رد آگهی</span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
//panel header
export function Header_panel(props) {
  return (
    <div class="row header_panel  justify-content-between">
      <h5 class="Header_panel_title">{props.title}</h5>
      <nav class="navbar navbar-dark">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target={props.idMenu}
          aria-controls="navbarToggleExternalContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </nav>
    </div>
  );
}

//panel header
export function Header_panel2({ title, idMenu, ShowList, setShowList }) {
  console.log("sdfsdfsdf" + ShowList);
  
    return (
      <div class="row header_panel  justify-content-between">
        <h5 class="Header_panel_title">{title}</h5>
        <nav class="navbar navbar-dark">
          <button
            class="navbar-toggler"
            onClick={() => setShowList(ShowList ? false : true)}
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        </nav>
      </div>
    );
  }
  

//check box
export function CheckBox(props) {
  return (
    <div class={props.class}>
      <label class="textg">
        {props.name} <input type="checkbox" value="" />
      </label>
    </div>
  );
}

//Toggle
export function Toggle(props) {
  return (
    <div class={props.class}>
      <form>
        <div class="custom-control custom-switch">
          <input
            onchange={props.onChange}
            checked={props.checked}
            type="checkbox"
            class="custom-control-input"
            id={props.id}
          />
          <label class="custom-control-label" for={props.id}>
            {" "}
            {props.title}
          </label>
        </div>
      </form>
    </div>
  );
}

//text area
export function Textarea(props) {
  return (
    <div class={props.class}>
      <div class="form-group textg">
        <label class="control-label">توضیحات</label>
        <textarea class="contactInput form-control" rows="8" cols="50">
          {" "}
        </textarea>
      </div>
    </div>
  );
}

//Icon
export function Icon(props) {
  return (
    <div class={props.class}>
      <img src={props.src} alt={props.alt} class={props.class} />
    </div>
  );
}

//Paging
export function Paging() {
  return (
    <div>
      <ul class="pagination justify-content-end">
        <li class="page-item">
          <a class="page-link" href="javascript:void(0);">
            Previous
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="javascript:void(0);">
            1
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="javascript:void(0);">
            2
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="javascript:void(0);">
            Next
          </a>
        </li>
      </ul>
    </div>
  );
}

//Paging
export function UploadImg() {
  return (
    <div class="input-group ">
      <div class="custom-file">
        <input
          type="file"
          class="custom-file-input"
          id="inputGroupFile01"
          aria-describedby="inputGroupFileAddon01"
        />
        <label class="custom-file-label" for="inputGroupFile01">
          آدرس تصویر
        </label>
      </div>
    </div>
  );
}

export function BtnDelet(props) {
  return (
    <div>
      <Button variant="warning" id={props.id}>
        حذف
      </Button>
    </div>
  );
}
export class ModalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div> {this.props.description}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export class ModalDetailUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div>
              {this.props.address}
              <span className=" float-right"> : آدرس </span>
            </div>
            <div>
              <span className="float-right"> : شناسه شرکت </span>
              {this.props.companyCode}
            </div>
            <div>
              <span className="float-right"> : توضیحات </span>
              {this.props.description}
            </div>
            <div>
              <span className="float-right"> : شناسه اقتصادی </span>
              {this.props.economicCode}
            </div>
            <div>
              <span className="float-right"> : نوع فعالیت </span>
              {this.props.activityType}
            </div>
            {this.props.otherDatas &&
              this.props.otherDatas.map((item, index) => {
                if (item && item.name && item.name == "instagram") {
                  return (
                    <div>
                      <label>{item && item.value && item.value}</label>
                      <label>: اینستاگرام </label>
                    </div>
                  );
                }
                if (item && item.name && item.name == "email") {
                  return (
                    <div>
                      <label>{item.value}</label>
                      <label>: رایانامه </label>
                    </div>
                  );
                }
                if (item && item.name && item.name == "fax") {
                  return (
                    <div>
                      <label>{item.value && item.value}</label>
                      <label>: فکس </label>
                    </div>
                  );
                }
              })}

            {/* <div>
              {this.props.province}
              <span className="float-right"> : استان </span>
            </div> */}
            {/* <div>
              {this.props.city}
              <span className="float-right"> : شهر </span>
            </div> */}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export class ModalDetailUser1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div>
              {this.props.address}
              <span className=" float-right"> : آدرس </span>
            </div>

            <div>
              <span className="float-right"> : توضیحات </span>
              {this.props.description}
            </div>
            <div>
              <span className="float-right"> : نام و نام خانوادگی ادمین </span>
              {this.props.townAdminFullName}
            </div>
            <div>
              <span className="float-right"> : موبایل ادمین </span>
              {this.props.townAdminMobile}
            </div>

            {/* <div>
              {this.props.province}
              <span className="float-right"> : استان </span>
            </div> */}
            {/* <div>
              {this.props.city}
              <span className="float-right"> : شهر </span>
            </div> */}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export class ModalDetailorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div>
              {this.props.address}
              <span className="float-right"> : آدرس </span>
            </div>
            <div>
              {" "}
              {this.props.number}{" "}
              <span className="float-right"> : شماره تماس </span>
            </div>
            <div>
              {" "}
              {this.props.proceedingCode}{" "}
              <span className="float-right"> : کد پیگیری </span>
            </div>
            <div>
              {" "}
              {this.props.paymentType}{" "}
              <span className="float-right"> : نوع پرداخت </span>
            </div>
            <div>
              {" "}
              {this.props.shipmentType}{" "}
              <span className="float-right"> : نحوه ارسال </span>
            </div>
            <div>
              {" "}
              {this.props.isCancel}{" "}
              <span className="float-right"> : وضعیت سفارش </span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
